"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var clear_overlapping_1 = tslib_1.__importDefault(require("./clear-overlapping"));
var datetime_string_abbrevaite_1 = tslib_1.__importDefault(require("./datetime-string-abbrevaite"));
var digits_abbreviate_1 = tslib_1.__importDefault(require("./digits-abbreviate"));
var node_jitter_1 = tslib_1.__importDefault(require("./node-jitter"));
var node_jitter_upward_1 = tslib_1.__importDefault(require("./node-jitter-upward"));
var nodes_resampling_1 = tslib_1.__importDefault(require("./nodes-resampling"));
var nodes_resampling_by_abbrevate_1 = tslib_1.__importDefault(require("./nodes-resampling-by-abbrevate"));
var nodes_resampling_by_change_1 = tslib_1.__importDefault(require("./nodes-resampling-by-change"));
var nodes_resampling_by_state_1 = tslib_1.__importDefault(require("./nodes-resampling-by-state"));
var robust_abbrevaite_1 = tslib_1.__importDefault(require("./robust-abbrevaite"));
var text_abbreviate_1 = tslib_1.__importDefault(require("./text-abbreviate"));
var text_hide_1 = tslib_1.__importDefault(require("./text-hide"));
var text_rotation_1 = tslib_1.__importDefault(require("./text-rotation"));
var text_wrapper_1 = tslib_1.__importDefault(require("./text-wrapper"));
exports.rulesLib = {
    textWrapper: text_wrapper_1.default,
    textRotation: text_rotation_1.default,
    textAbbreviate: text_abbreviate_1.default,
    textHide: text_hide_1.default,
    digitsAbbreviate: digits_abbreviate_1.default,
    datetimeStringAbbrevaite: datetime_string_abbrevaite_1.default,
    robustAbbrevaite: robust_abbrevaite_1.default,
    nodesResampling: nodes_resampling_1.default,
    nodesResamplingByAbbrevate: nodes_resampling_by_abbrevate_1.default,
    nodesResamplingByChange: nodes_resampling_by_change_1.default,
    nodesResamplingByState: nodes_resampling_by_state_1.default,
    nodeJitter: node_jitter_1.default,
    nodeJitterUpward: node_jitter_upward_1.default,
    clearOverlapping: clear_overlapping_1.default,
};
function registerResponsiveRule(name, method) {
    // todo: 防止覆盖
    exports.rulesLib[name] = method;
}
exports.registerResponsiveRule = registerResponsiveRule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/util/responsive/rules/index.js
// module id = 635
// module chunks = 37